import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import Branch from "./Module/BranchStore";
import Membership from "./Module/MembershipStore";
import About from "./Module/AboutStore";
import Program from "./Module/ProgramStore";
import VenueHire from "./Module/VenueHireStore";
import Article from "./Module/ArticleStore";
import Faq from "./Module/FaqStore";
import ServiceMenu from "./Module/ServiceMenuStore";
import Contact from "./Module/ContactStore";
import Landing from "./Module/LandingPageStore";
import Search from "./Module/SearchStore";
import FreePage from "./Module/FreePageStore";
Vue.use(Vuex);
const modules = {
    Branch,
    Membership,
    About,
    Program,
    VenueHire,
    Article,
    Faq,
    ServiceMenu,
    Contact,
    Landing,
    Search,
    FreePage
};

export default new Vuex.Store({
    modules,
    plugins: [createPersistedState()]
});
